import type { SiteContent } from '../../content/types';
import { Button } from '../ui/button';

interface MobileStickyCtaProps {
  content: SiteContent;
}

export function MobileStickyCta({ content }: MobileStickyCtaProps): JSX.Element {
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t border-[color:var(--color-border)] bg-white/95 p-3 backdrop-blur-md lg:hidden">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-2">
        <Button asChild size="sm" className="h-11">
          <a href={content.hero.primaryCta.href}>{content.hero.primaryCta.label}</a>
        </Button>
        <Button asChild size="sm" variant="outline" className="h-11">
          <a href={content.hero.secondaryCta.href}>{content.hero.secondaryCta.label}</a>
        </Button>
      </div>
    </div>
  );
}
